var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"},on:{"~click":function($event){return _vm.hide.apply(null, arguments)}}},[(!_vm.isHidden)?_c('Preview'):_vm._e(),(_vm.isHidden)?_c('div',[_c('Header'),_c('router-view')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }